import { HtmlHTMLAttributes } from 'react';

import { Label } from '@/components/form/label';

export function LayoutStep(props: HtmlHTMLAttributes<HTMLDivElement>) {
  return (
    <section {...props} className="text-center flex-1 flex-full-center flex-col w-full mt-12" />
  );
}

export function FooterButtons({ children, ...props }: HtmlHTMLAttributes<HTMLDivElement>) {
  return (
    <footer {...props} className="flex-1 flex justify-center items-end gap-4 mt-8 pb-12">
      <div className="inline-flex-full-center gap-x-2">{children}</div>
    </footer>
  );
}

type DeepQuestionSectionProps = HtmlHTMLAttributes<HTMLDivElement> & { label: string };
export function DeepQuestionSection({ label, children, ...props }: DeepQuestionSectionProps) {
  return (
    <>
      <Label>{label}</Label>
      <div {...props} className="flex flex-wrap gap-x-4 gap-y-2 mb-2 max-w-full">
        {children}
      </div>
    </>
  );
}
